import { render, staticRenderFns } from "./shopPortal.vue?vue&type=template&id=6ded7fa8&scoped=true&"
import script from "./shopPortal.vue?vue&type=script&lang=js&"
export * from "./shopPortal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ded7fa8",
  null
  
)

export default component.exports